import React, { useContext } from 'react';
import { AppNameContext } from '../contexts/AppNameProvider';

interface UserInterface {
  roles: string[];
}

export enum PolicyMatchMode {
  ALL = 'ALL',
  ANY = 'ANY',
}

interface PolicyProps<TUser extends UserInterface> {
  user?: TUser | null;
  roles: string[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
  matchMode?: PolicyMatchMode;
}

export function Policy<TUser extends UserInterface>(
  props: PolicyProps<TUser>
): JSX.Element | null {
  const {
    user,
    roles,
    children,
    fallback,
    matchMode = PolicyMatchMode.ALL,
  } = props;

  const appName = useContext(AppNameContext);

  if (!appName) {
    throw new Error('AppNameContext is not set.');
  }

  const userRoles = user?.roles ?? [];

  const authorized =
    user &&
    (matchMode === PolicyMatchMode.ALL
      ? roles.every((role) => userRoles.includes(`${appName}/${role}`))
      : roles.some((role) => userRoles.includes(`${appName}/${role}`)));

  if (authorized) {
    return <>{children}</>;
  }

  if (fallback) {
    return <>{fallback}</>;
  }

  return null;
}
